export const USAGE_ERR_PERCENTAGE = 90;
export const USAGE_WARN_PERCENTAGE = 70;
export const MAX_FILE_LIMIT = 1000000;
export const youTubeUrl =
  'https://www.youtube.com/watch?v=2joYuwtFWVo&feature=youtu.be';
export const aiSiteYouTubeUrl = 'https://www.youtube.com/watch?v=d7i_epuskv0';
export const aiStoreYouTubeUrl = 'https://www.youtube.com/watch?v=tn_1BnRuTRg';

const ADDON_AGE_THRESHOLD_MINUTES = 8;
export const ADDON_AGE_THRESHOLD_MS = ADDON_AGE_THRESHOLD_MINUTES * 60 * 1000; // Threshold in milliseconds to determine if the Pending banner can be removed for VPS Self Managed.

export const PRODUCT_LICENCES_URL = '/my-account/product-licenses';
export const FREE_TRIAL_UPGRADE_URL =
  '/my-account/hosting/wordpress-purchase-redirect';

export const SUSPENDED_STATES = ['disable', 'disabled'];
export const DECOM_STATES = [
  'decom',
  'pending_decom',
  'failed_decom',
  'pending_stop_decom',
  'failed_stop_decom',
];
export const DELETED_STATES = ['deleted', 'pending_destroy', 'destroy'];
export const FAILED_STATES = ['failed_create'];
export const PENDING_STATES = ['create', 'pending_create', 'renew'];
export const PENDING_CREATE_STATES = ['create', 'pending_create'];

export const DISABLE_STATUSES = [
  'disable',
  'disabled',
  'pending_destroy',
  'destroy',
  'deleted',
  'decom',
  'pending_decom',
  'failed_decom',
  'pending_stop_decom',
  'failed_stop_decom',
];

export const ADVANCED_HOSTING_TYPES = [
  'vps',
  'dedicated',
  'vps_cpanel',
  'dedicated_cpanel',
  'dedicated_plesk',
  'dedicated_windows',
  'vps_windows_plesk',
];

export const ACCOUNT_TYPES_INVALID_FOR_DOMAIN = new Set([
  'dedicated_windows',
  'dedicated_plesk',
  'shared_plesk',
  'vps_plesk',
  'vps_windows',
]);

export const HOSTING_TYPES_WITHOUT_SERVER_IMAGE_TOOLTIP = new Set([
  'vps_cpanel',
  'dedicated',
  'dedicated_cpanel',
]);

export const VIDEO_ARTICLE_CARD_CONFIG = {
  aiStore: {
    titleI18nKey: 'videoArticleCard.aiStore.title',
    descriptionI18nKey: 'videoArticleCard.aiStore.description',
    videoUrl: aiStoreYouTubeUrl,
  },
  aiSite: {
    titleI18nKey: 'videoArticleCard.aiSite.title',
    descriptionI18nKey: 'videoArticleCard.aiSite.description',
    videoUrl: aiSiteYouTubeUrl,
  },
} as const;
